import PropTypes from 'prop-types'

import ClickableIcon from '@/components/ClickableIcon'
import { Delete } from '@/components/Icons'
import attributeShape from '@/pages/OrganizationUserAttributesPage/attributeShape'

const DeleteIconTooltip = ({ attribute, onClick }: any) => {
  // TODO Remove this onClick and wrap it in a button
  return attribute.custom ? <ClickableIcon callback={onClick} parameter={attribute.id} render={Delete} /> : null
}

DeleteIconTooltip.displayName = 'DeleteIconTooltip'

DeleteIconTooltip.propTypes = {
  attribute: attributeShape.isRequired,
  onClick: PropTypes.func
}

DeleteIconTooltip.defaultProps = {
  onClick: () => {}
}

export default DeleteIconTooltip
